<template>
<div class="prices">
  <!-- <ui-loader v-model="loading" ref="loader"/> -->
  <v-container>
    <v-window v-model="step">
      <v-window-item :value="1">
        <v-layout wrap>

          <v-flex>
            <v-form @submit="chageStep" v-model="valid" ref="updatePricesForm" onSubmit="return false;">

              <v-card>

                <v-card-title primary-title>
                  <div>
                    <h1 class="d-inline-block">Precios</h1> 
                    <h4 
                      class="d-inline-block" 
                      style="margin-left: 10px;"
                      v-if="statusPrices"
                      >({{statusPrices}})</h4>
                  </div>
                </v-card-title>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs4 tag="h2" class="pt-3">Platino</v-flex>
                    <v-flex xs3 tag="h3" class="grey--text pt-4 text-xs-right">
                      {{currentPrices.platinum_price | currency}}
                      <v-flex xs1></v-flex>
                    </v-flex>
                    <v-flex xs1></v-flex>
                    <v-flex xs3>
                      <v-text-field name="Platino" id="pt" :solo="solo" :outline="outline" 
                        :rules="required"
                        :box="box" numeric v-model='updatedPrices.platinum_price'>
                      </v-text-field>
                    </v-flex>
                    <v-flex xs1 class="text-xs-center pt-3">
                      <v-icon v-if="updatedPrices.platinum_price && updatedPrices.platinum_price > currentPrices.platinum_price" color="green" medium>trending_up</v-icon>
                      <v-icon v-if="updatedPrices.platinum_price && updatedPrices.platinum_price < currentPrices.platinum_price" color="red" medium>trending_down</v-icon>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 tag="h2" class="pt-3">Paladio</v-flex>
                    <v-flex xs3 tag="h3" class="grey--text pt-4 text-xs-right">
                      {{currentPrices.paladium_price | currency}}
                    </v-flex>
                    <v-flex xs1></v-flex>
                    <v-flex xs3>
                      <v-text-field name="Paladio" id="pl" :solo="solo" :outline="outline" 
                        :rules="required"
                        :box="box" numeric v-model='updatedPrices.paladium_price'>
                      </v-text-field>
                    </v-flex>
                    <v-flex xs1 class="text-xs-center pt-3">
                      <v-icon v-if="updatedPrices.paladium_price && updatedPrices.paladium_price > currentPrices.paladium_price" color="green" medium>trending_up</v-icon>
                      <v-icon v-if="updatedPrices.paladium_price && updatedPrices.paladium_price < currentPrices.paladium_price" color="red" medium>trending_down</v-icon>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 tag="h2" class="pt-3">Rodio</v-flex>
                    <v-flex xs3 tag="h3" class="grey--text pt-4 text-xs-right">
                      {{currentPrices.rodium_price | currency}}
                    </v-flex>
                    <v-flex xs1></v-flex>
                    <v-flex xs3>
                      <v-text-field name="Rodio" id="rh" :solo="solo" :outline="outline" 
                        :rules="required"
                        :box="box" numeric v-model='updatedPrices.rodium_price'>
                      </v-text-field>
                    </v-flex>
                    <v-flex xs1 class="text-xs-center pt-3">
                      <v-icon v-if="updatedPrices.rodium_price && updatedPrices.rodium_price > currentPrices.rodium_price" color="green" medium>trending_up</v-icon>
                      <v-icon v-if="updatedPrices.rodium_price && updatedPrices.rodium_price < currentPrices.rodium_price" color="red" medium>trending_down</v-icon>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 tag="h2" class="pt-3">Dolar</v-flex>
                    <v-flex xs3 tag="h3" class="grey--text pt-4 text-xs-right">
                      {{currentPrices.dollar_price | currency}}
                    </v-flex>
                    <v-flex xs1></v-flex>
                    <v-flex xs3>
                      <v-text-field name="Dolar" id="dll" :solo="solo" :outline="outline" 
                        :rules="required"
                        :box="box" numeric v-model='updatedPrices.dollar_price'>
                      </v-text-field>
                    </v-flex>
                    <v-flex xs1 class="text-xs-center pt-3">
                      <v-icon v-if="updatedPrices.dollar_price && updatedPrices.dollar_price > currentPrices.dollar_price" color="green" medium>trending_up</v-icon>
                      <v-icon v-if="updatedPrices.dollar_price && updatedPrices.dollar_price < currentPrices.dollar_price" color="red" medium>trending_down</v-icon>
                    </v-flex>
                  </v-layout>

                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn type="submit"  color="success" :disabled="!valid">Siguiente</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>

          </v-flex>

        </v-layout>
      </v-window-item>
      <v-window-item :value="2">
        <v-layout>
          <v-flex>
            <v-form @submit="updatePrices" v-model="valid" ref="updatePricesForm" onSubmit="return false;">
              <v-card>
                <v-card-title primary-title>
                  <v-container>
                    
                  
                  <v-layout row wrap>
                    <v-flex tag="h1" xs12>
                      Modificaciones de Precios    
                    </v-flex>
                  
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs3>
                      Platino<br/>
                      {{currentPrices.platinum_price | currency}}<br/>
                      {{updatedPrices.platinum_price | currency}}
                    </v-flex>
                    <v-flex xs3>
                      Paladio<br/>
                      {{currentPrices.paladium_price | currency}}<br/>
                      {{updatedPrices.paladium_price | currency}}
                    </v-flex>
                    <v-flex xs3>
                      Rodio<br/>
                      {{currentPrices.rodium_price | currency}}<br/>
                      {{updatedPrices.rodium_price | currency}}
                    </v-flex>
                    <v-flex xs3>
                      Dolar<br/>
                      {{currentPrices.dollar_price | currency}}<br/>
                      {{updatedPrices.dollar_price | currency}}
                    </v-flex>
                  </v-layout>
                  </v-container>
                </v-card-title>
                <v-card-text>
                  <v-list three-line>
                    <template v-for="product in products">
                      <v-list-tile
                        :key="product.title"
                      >
                        <v-list-tile-content>
                          <v-list-tile-title >{{product.serial_number}}</v-list-tile-title>
                          <v-list-tile-sub-title>
                            
                            Anterior: <span class="grey--text">{{product.oldValues.pesos_price| currency}}</span>  -> 
                            Nuevo: <span class="grey--text">{{product.newValues.pesos_price | currency}} </span>
                            Diferencia: <span class="grey--text">{{product.newValues.pesos_price - product.oldValues.pesos_price | currency}} </span>
                            <v-icon v-if="product.newValues.pesos_price - product.oldValues.pesos_price > 0.001" color="green" medium>trending_up</v-icon>
                            <v-icon v-if="product.newValues.pesos_price - product.oldValues.pesos_price < -0.001" color="red" medium>trending_down</v-icon>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider                      
                        :key="product.id"
                        inset
                      ></v-divider>

                    </template>
                  </v-list>
                </v-card-text>
                <v-card-actions>
                  <v-btn  icon @click="step=1">
                    <v-icon>arrow_back_ios</v-icon>
                  </v-btn>
          
                  <v-spacer></v-spacer>
                  <v-btn type="submit"  :disabled="!valid" class=" { 'blue-grey darken-2 white--text' }">Guardar</v-btn>
                </v-card-actions>
              </v-card>            
            </v-form>
          </v-flex>
        </v-layout>
      </v-window-item>
    </v-window>
     <v-snackbar v-model="snackShow" :color="snackColor" :timeout="8000" :vertical="true" top>
        {{ snckMessage }}
        <v-btn dark flat @click="snackShow = false">
          Cerrar
        </v-btn>
      </v-snackbar>
  </v-container>
</div>
</template>

<script>
export default {
  name: 'Prices',
  data() {
    return {
      outline: false,
      solo: true,
      box: true,
      valid: false,
      snackShow: false,
      snckMessage: '',
      snackColor: '',
      icon: 'trending_up',
      icondown: 'trending_down',
      // inputIcon: 'attach_money',
      inputIcon: false,
      initialupdatedPrices: {
        paladium_price: undefined,
        platinum_price: undefined,
        rodium_price: undefined,
        dollar_price: undefined,
      },
      updatedPrices: {
        paladium_price: undefined,
        platinum_price: undefined,
        rodium_price: undefined,
        dollar_price: undefined,
      },
      currentPrices: {
        paladium_price: 0.0,
        platinum_price: 0.0,
        rodium_price: 0.0,
        dollar_price: 0.0,
      },
      step: 1,
      products: [],
      loading: false,
      statusPrices: '',
      // Form validations
      required: [
        (v) => !!v || 'Campo requerido',
      ],
    };
  },

  async created() {
    const currentPrices = await this.axios.get('/catalogs/basePrice');
    this.currentPrices = currentPrices.data;
    this.checkPriceStatus()
  },

  methods: {
    async checkPriceStatus() {
      const statusPrice = await this.axios.get('/catalogs/product/status/update');
      this.updatedStatusText(statusPrice.data.updateStatus)
    },
    updatedStatusText(code) {
      switch(code) {
        case 'NONE':
          this.statusPrices = 'Sin cambios pendientes de actualizar'
          break;
        case 'PENDING':
          this.statusPrices = 'Actualización de precios programada'
          break;
        case 'UPDATING':
          this.statusPrices = 'Actualización en curso'
          break;
      }
    },
    chageStep() {
      this.step = 2;
      let cotization =  {
        days_out : 0.00,
        lease_rate : 0.00,
        perc_return_pt : 96,
        perc_return_pl : 96,
        perc_return_rh : 90,
      };
      cotization = Object.assign(cotization, this.updatedPrices);
      const body = {
        cotization,
        serialNumberList: ['F4TA NAP', '2C3C REG', '2M0'],
      };
      this.axios.post('/catalogs/products/checkPricesUpdate', body)
      .then( (response) => {
        this.products = response.data;
      })
      .catch( (err) => {
        // console.log(err);
      });
    },
    updatePrices() {
      this.loading = true;
      const body = Object.assign({}, this.updatedPrices);
      body.paladium_price = body.paladium_price.replace(',', '');
      body.platinum_price = body.platinum_price.replace(',', '');
      body.rodium_price = body.rodium_price.replace(',', '');
      body.dollar_price = body.dollar_price.replace(',', '');
      this.axios.post('/catalogs/basePrice', body)
        .then((result) => {
          console.log(result);
          this.loading = false;
          if (result.data.statusCode === 226){
            this.snckMessage = 'Servicio actualizando histórico y productos. Intente mas tarde';
            this.snackColor = 'red lighten-2';
            this.snackShow = true;
          }else{
            this.snckMessage = 'Se programo correctamente el cambio de precios';
            this.snackColor = 'green lighten-2';
            this.step = 1;      
            this.currentPrices = Object.assign({}, this.updatedPrices);
            this.updatedPrices = Object.assign({}, this.initialupdatedPrices);
            this.updatedPrices.platinum_price = undefined
            // this.$refs.loader.set(this.loading);
          }
          setTimeout(() => {
            this.checkPriceStatus()
          }, 1000);
          this.snackShow = true;
        })
        .catch((error) => {
          this.snckMessage = error.response;
          if (error.response) {
            this.snckMessage = error.response.sqlMessage;
          }
          this.snackColor = 'red lighten-2';
          this.snackShow = true;
          this.loading = false;
          // this.$refs.loader.set(this.loading);
        });
    },

  },
};
</script>
